import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getContracts: function(params, search, status) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/billing/contracts" + params + search + status);
  },
  downloadContractPdf: function(uuid) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/billing/contracts/" + uuid + "/pdf", {
      responseType: 'blob',
    });
  },
  replaceContract: function(uuid, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(IMPROVE_CONFIG.API_URL + "/billing/contracts/" + uuid + "/replace", formData, {
      headers: {
        'content-type': 'multipart/form-data; boundary=${formData._boundary}',
      },
    });
  },
};
